import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FactorNameServices from "./FactorName.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getFactorName = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR_NAME,
      payload: true,
    });
    const resp = await FactorNameServices.getFactorName(filters);
    dispatch({
      type: actions.GET_FACTOR_NAME,
      payload: resp.data,
    });
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR_NAME,
      payload: false,
    });
  }
};

export const getFactorNameById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR_NAME,
      payload: true,
    });
    const resp = await FactorNameServices.getFactorNameById(id);
    dispatch({
      type: actions.GET_FACTOR_NAME,
      payload: resp.data,
    });
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR_NAME,
      payload: false,
    });
  }
};

export const saveFactorName = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_FACTOR_NAME,
      payload: true,
    });
    const resp = await FactorNameServices.saveFactorName(req);
    const { data, count } = getState().factorName.factorName;
    const _data = [...data, resp.data];
    dispatch({
      type: actions.GET_FACTOR_NAME,
      payload: {
        data: _data,
        count: count + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_FACTOR_NAME,
      payload: false,
    });
  }
};

export const editFactorName = (req, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR_NAME,
      payload: true,
    });
    const resp = await FactorNameServices.editFactorName(id, req);
    const { data, count } = getState().factorName.factorName;
    data[index] = resp.data;
    dispatch({
      type: actions.GET_FACTOR_NAME,
      payload: {
        data: data,
        count: count,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR_NAME,
      payload: false,
    });
  }
};

export const deleteFactorName = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR_NAME,
      payload: true,
    });
    await FactorNameServices.deleteFactorName(id);
    const { data, count } = getState().factorName.factorName;
    data.splice(index, 1);
    dispatch({
      type: actions.GET_FACTOR_NAME,
      payload: {
        data: data,
        count: count - 1,
      },
    });
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data[0]){
              message = ex.response.data[0];
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR_NAME,
      payload: false,
    });
  }
};
